module.exports = __webpack_public_path__ + "img/user-profile.74f30757.svg";